<style lang="scss" scoped></style>

<template lang="pug">
.run-reports
	reports-table(:reports="reports")
</template>

<script>
import ReportsTable from "@/views/reports/includes/ReportsTable";
import ReportsQuery from "@/graphql/queries/Reports";

export default {
	name: "SchoolReports",
	components: {
		ReportsTable
	},

	apollo: {
		reports: {
			query: ReportsQuery,
			variables() {
				return {
					school_id: this.$route.params.school
				};
			},
			update: r => {
				return r.Reports.results;
			},
			fetchPolicy: "cache-and-network"
		}
	}
};
</script>
